import React, { FC } from "react";
import LatestFinancialHeader from "./LatestFinancialHeader";
import LatestFinancialResultClientMain from "./LatestFinancialResultClientMain";
import { getFlipitNews } from "../../services/TradingMallService";
import BFLApiFailure from "@repo/shared-ui/BFLApiFailure";
import StockListNotFound from "../ClpStockCards/StockListNotFound";

interface LatestFinancialResultMainProps {
  mainHeading?: string;
  heading?: string;
  description?: string;
  componentPosition?: string;
}

const LatestFinancialResultMain: FC<LatestFinancialResultMainProps> = async ({
  mainHeading = "All latest financial results are listed below",
  heading = "Latest financial results",
  description = "Explore Latest financial results and start investing right away.",
  componentPosition,
}) => {
  let newsItems: any[] = [];
  let showMore = false;
  let showLess = false;
  let hasError = false;

  try {
    const response = await getFlipitNews(1, 10);
    const news = response?.data?.news ?? [];
    newsItems = news;
    showMore = response?.data?.showMore ?? false;
    showLess = response?.data?.showLess ?? false;
  } catch (error) {
    console.error("Failed to load financial results for main page:", error);
    hasError = true;
  }

  // Error state: show header + API failure (mirrors OtherNews pattern)
  if (hasError && newsItems.length === 0) {
    return (
      <>
        <p className="hidden sm:block py-[14px] pl-[24px] text-[14px] text-[#222F3F] font-[400px] border-b-2 border-[#E5EAF7]">
          {mainHeading}
        </p>
        <div className="flex flex-row">
          <div className="hidden sm:block w-[243px] border-r-2 border-[#E5EAF7]" />
          <div className="flex flex-col gap-[12px] px-[16px] py-[12px]">
            <LatestFinancialHeader
              header={heading}
              description={description}
            />
            <div className="block md:hidden border-b-2 border-[#E5EAF7]" />
            <div className="flex min-h-[400px] items-center justify-center py-12">
              <BFLApiFailure
                imageSrc=""
                imageAlt="Error"
                error="Unable to fetch the information at this time"
                errorDescription="Please try again later"
                retryButtonText="Retry"
              />
            </div>
          </div>
        </div>
      </>
    );
  }

  // Empty state: show header + simple empty message
  if (!hasError && newsItems.length === 0) {
    return (
      <>
        <p className="hidden sm:block py-[14px] pl-[24px] text-[14px] text-[#222F3F] font-[400px] border-b-2 border-[#E5EAF7]">
          {mainHeading}
        </p>
        <div className="flex flex-row">
          <div className="hidden sm:block w-[243px] border-r-2 border-[#E5EAF7]" />
          <div className="flex flex-col gap-[12px] px-[16px] py-[12px]">
            <LatestFinancialHeader
              header={heading}
              description={description}
            />
            <StockListNotFound
              errorMessage="No financial results available at the moment."
              stockNotFoundImgUrl="https://cms-assets.bajajfinserv.in/is/image/bajajfinance/no-stocks"
            />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <p className="hidden sm:block py-[14px] pl-[24px] text-[14px] text-[#222F3F] font-[400px] border-b-2 border-[#E5EAF7]">
        {mainHeading}
      </p>
      <div className="flex flex-row">
        <div className="hidden sm:block w-[243px] border-r-2 border-[#E5EAF7]" />
        <div className="flex flex-col gap-[12px] ">
          <LatestFinancialHeader
            customClass="px-[16px] pt-[12px]"
            header={heading}
            description={description}
          />
          <div className="border-b-2 border-[#E5EAF7] md:hidden" />
          <div className="px-[16px] pb-[12px]">
          <LatestFinancialResultClientMain
            stocks={newsItems}
            initialShowMore={showMore}
            initialShowLess={showLess}
            sectionTitle={heading}
            componentPosition={componentPosition}
          />
        </div>
      </div>
      </div>
    </>
  );
};

export default LatestFinancialResultMain;

